<div
  class="contact-container"
  [ngClass]="{ 'contact-container-outside-card': outsideCard }"
>
  <h2>{{ "contact.title" | translate }}</h2>
  <div class="info-container">
    <div *ngIf="isSweden" class="row">
      <div class="icon icon-comment"></div>
      <div class="text-container">
        <p class="left-text">{{ "contact.chatLabel" | translate }}:</p>
        <p class="right-text">
          <span (click)="openChat()" class="link-style">
            {{ "contact.chatLink" | translate }}
          </span>
          {{ "contact.chat" | translate }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="icon icon-email"></div>
      <div class="text-container">
        <p class="left-text">{{ "contact.emailLabel" | translate }}:</p>
        <p class="right-text">{{ "contact.email" | translate }}</p>
      </div>
    </div>
    <div class="row" *ngIf="isSweden">
      <div class="icon icon-phone"></div>
      <div class="text-container">
        <p class="left-text">{{ "contact.phoneNumberLabel" | translate }}:</p>
        <p class="right-text">{{ "contact.phoneNumber" | translate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="icon icon-clock"></div>
      <div class="text-container">
        <p class="left-text">{{ "contact.openingHoursLabel" | translate }}:</p>
        <p class="right-text">{{ "contact.openingHours" | translate }}</p>
      </div>
    </div>
    <div *ngIf="!isSweden" class="row">
      <div class="icon icon-question"></div>
      <div class="text-container">
        <p class="left-text">{{ "contact.faqLabel" | translate }}:</p>
        <p class="right-text">
          <a [href]="faqLink" target="_blank">
            {{ "contact.faqLink" | translate }}</a
          >
          {{ "contact.faq" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
